import { Box, IconButton, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ButtonZoom } from "../../v2/utils/ButtonZoom";
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    color: "#0288D1",
  },
  closeButton: {
    marginLeft: "auto",
    color: theme.palette.text.secondary,
  },
}));

interface AppBarBannerProps {
  variant: "text" | "button";
  sticky?: boolean;
  message?: string | JSX.Element;
  backgroundColor?: string;
  icon?: string;
  buttonText?: string;
  height?: number;
  buttonOnClick?: () => void;
  onClose?: () => void;
}

export const AppBarBanner = (props: AppBarBannerProps) => {
  const classes = useStyles();
  const { variant, message, backgroundColor, icon, buttonText, buttonOnClick, height } =
    props;
  if (variant === "text") {
    return (
      <>
        <Box
          sx={{
            background: `${backgroundColor} 0% 0% no-repeat padding-box`,
            width: "100%",
            height: height ? `${height}px` : "48px",
            minHeight: height ? `${height}px` : "48px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingX: "24px",
            ...(props.sticky && { position: "sticky", top: "0px", zIndex: 500 }),
          }}>
          {props.onClose && (
            <Box sx={{ marginRight: "auto", width: "32px" }}>
              {/* empty box for flex justification */}
            </Box>
          )}
          <Typography
            sx={{ font: "normal normal 500 14px/22px Roboto", color: "#0D3C61" }}
            component="div">
            <i className={`far ${icon} fa-lg ${classes.infoIcon}`}></i>
            <span style={{ marginLeft: "15px" }}>{message}</span>
          </Typography>
          {props.onClose && (
            <IconButton
              onClick={props.onClose}
              aria-label="hide this message"
              className={classes.closeButton}
              size="small">
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </>
    );
  } else if (variant === "button") {
    return (
      <>
        <Box
          sx={{
            background: `${backgroundColor} 0% 0% no-repeat padding-box`,
            width: "100%",
            height: "72px",
            paddingTop: "16px",
            paddingBottom: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...(props.sticky && { position: "sticky", top: "0px", zIndex: 500 }),
          }}>
          <ButtonZoom
            disableZoom={true}
            sx={{
              width: "119px",
              height: "35px",
              borderRadius: "8px",
              borderShadow: "0px 3px 6px #00000029",
            }}
            size={"small"}
            variant="contained"
            color="secondary"
            onClick={buttonOnClick}>
            {buttonText}
          </ButtonZoom>
        </Box>
      </>
    );
  } else {
    return <></>;
  }
};
